import { io } from "socket.io-client";
import Parse from "parse";

let socket = null;
let reconnectTimeout = null;
let alreadyInitialized = false;

export const initializeWebSocket = (onMessageCallback) => {
  // Return existing socket if already connected
  if (socket && socket.connected) {
    return socket;
  }
  
  if (alreadyInitialized) return socket;
  alreadyInitialized = true;

  const connect = () => {
    const currentUser = Parse.User.current();
    const token = currentUser ? currentUser.getSessionToken() : null;

    if (!token) {
      console.error("No session token found. User must log in.");
      return;
    }

    // Connect via Socket.IO instead of WebSocket
    socket = io(process.env.REACT_APP_SOCKET_CONNECTION_URL, {
      query: { token },
      transports: ["websocket"], // optional: force WebSocket transport
      reconnection: false, // Disable auto-reconnect to prevent infinite loop with backend duplicate detection
    });

    socket.on("connect", () => {
      console.log("✅ Socket.IO connected");
      // Make socket globally accessible when connected
      if (typeof window !== 'undefined') {
        window.socket = socket;
      }
    });

    socket.on("disconnect", (reason) => {
      console.warn("❌ Socket.IO disconnected:", reason);
      // Optionally handle reconnect logic manually
    });

    socket.on("connect_error", (err) => {
      console.error("🚨 Connection error:", err.message);
    });

    socket.onAny((event, payload) => {
      try {
        const parsed = typeof payload === "string" ? JSON.parse(payload) : payload;

        // Auto logout on token issues
        if (parsed?.message?.includes("invalid token")) {
          console.warn("🔒 Invalid session token. Logging out...");
          Parse.User.logOut().then(() => localStorage.clear());
        }

        if (onMessageCallback) onMessageCallback(event, parsed);
      } catch (e) {
        console.error("❌ Failed to parse message", e);
      }
    });
  };

  // Handle visibility/network reconnect
  window.addEventListener("online", connect);
  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "visible") connect();
  });

  connect();
  
  return socket;
};

export const sendWebSocketMessage = (eventName, data = {}) => {
  if (socket && socket.connected) {
    socket.emit(eventName, data);
  } else {
    console.warn("⚠️ Socket.IO is not connected. Cannot send message.");
  }
};
